export default "__VITE_ASSET__0jNMrs8P__"